import { Component, HostListener, OnInit, QueryList, ViewChildren, ViewEncapsulation } from '@angular/core';
import { NgbdSortableHeader, SortEvent } from '../../../../shared/directives/NgbdSortableHeader';
import { Observable, firstValueFrom } from 'rxjs';
import { PropietarioService } from '../../../../shared/services/propietarios.service';
import { Router } from '@angular/router';
import jsPDF from 'jspdf';
import { Utils } from '../../../../shared/utils/Utils';
import { gpcGoogleService } from '../../../../shared/services/gpcGoogle.service';
import { PDFDocument, rgb, StandardFonts } from 'pdf-lib';
import { ToastrService } from 'ngx-toastr';
import { AdministracionService } from '../../../../shared/services/administracion.services';
import { Administracion } from '../../../../shared/model/administracion.model';
import { DocumentosService } from '../../../../shared/services/documentos.Service';
import { AuthService } from '../../../../shared/services/auth.service';

const Swal = require("sweetalert2");


@Component({
  selector: 'app-listados',
  templateUrl: './listados.component.html',
  styleUrls: ['./listados.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ListadosComponent implements OnInit {
  isLoading: boolean = false;
  /**
   * Detecta la extensión real del soporte cargado en Google Cloud para un path base.
   * Prueba las extensiones comunes y retorna la primera que existe.
   * @param basePath Ruta base sin extensión
   * @param extensiones Lista de extensiones a probar (por defecto jpg, png, pdf)
   * @returns {Promise<string|null>} La extensión encontrada (sin punto) o null si no existe
   */
  async detectarExtensionSoporte(basePath: string, extensiones: string[] = ['jpg', 'png', 'pdf']): Promise<string | null> {
    for (const ext of extensiones) {
      const path = `${basePath}.${ext}`;
      try {
        const res = await this.gpcGoogle.getSignedUrl(path).toPromise();
        if (res?.url) {
          return ext;
        }
      } catch {
        // Continúa con la siguiente extensión
      }
    }
    return null;
  }
  public selected = [];
  archivos: any[] = [];
  public searchText = ''; // Texto para búsqueda
  total$: Observable<number>; // Observable para obtener el total de elementos
  propietarios: any[] = [];
  propietario: any[] = [];
  public show: boolean = false
  openDropdown: any = null; // Variable para controlar qué menú está abierto
  openDropdown2: any = null; // Variable para controlar qué menú está abierto
  sortColumn: string = '';
  sortDirection: string = 'asc'; // 'asc' o 'desc'
  searchTerm: string = '';
  dropdownStates: boolean[] = [];
  mostrandoToast = false;
  @ViewChildren(NgbdSortableHeader) headers: QueryList<NgbdSortableHeader>; // Para la cabecera de la tabla
  fotoBase64: string;
  base64CC1: string;
  base64CC2: string;
  base64LPF: string;
  base64LPP: string;
  filteredTableItems: PropietarioService[];
  empresaId: any;
  administraciones: Administracion[] = [];
  urlPdfRut: string | null = null;
  urlPdfCtp: string | null = null;
  urlPdfExm: string | null = null;
  urlPdfCmd: string | null = null;
  urlPdfSss: string | null = null;
  altura: number = 0;
  ancho: number = 0;
  posicionX: number = 0;
  posicionY: number = 0;

  constructor(private propietarioService: PropietarioService,
    private router: Router, private gpcGoogle: gpcGoogleService,
    private toastrService: ToastrService,
    private administracionesServices: AdministracionService,
    private documentosService: DocumentosService,
    private auth: AuthService

  ) { }

  ngOnInit() {

    this.listarPropietarios();
    this.cargarDataAdmin();

  }

  pageSize: number = 5;
  page: number = 1;
  totalItems: number;

  @HostListener('document:click', ['$event'])
  closeDropdown(event: Event) {
    this.openDropdown = null;
    this.openDropdown2 = null;
  }

  stopPropagation(event: Event) {
    event.stopPropagation(); // Evita que el clic dentro del dropdown cierre el menú
  }
  // Función para ordenar las columnas
  onSort({ column, direction }: SortEvent) {
    // Restablecemos la dirección de orden de todas las columnas
    this.headers.forEach((header) => {
      if (header.sortable !== column) {
        header.direction = '';
      }
    });

    // Establecemos la columna y dirección de orden
    // this.service.sortColumn = column;
    // this.service.sortDirection = direction;
  }


  get filteredPropietarios() {
    if (!this.searchTerm) {
      return this.propietarios; // Mostrar todos los datos si no hay búsqueda
    }

    const term = this.searchTerm.toLowerCase();
    return this.propietarios.filter(propietario => {
      // Ajusta los campos por los que quieres buscar
      return (
        propietario.primernombre.toLowerCase().includes(term) ||
        propietario.segundonombre.toLowerCase().includes(term) ||
        propietario.papellidos.toLowerCase().includes(term) ||
        propietario.seapellidos.toLowerCase().includes(term) ||
        propietario.cedula.toLowerCase().includes(term) ||
        propietario.mail.toLowerCase().includes(term) ||
        propietario.numerolic.toLowerCase().includes(term) ||
        propietario.direccion.toLowerCase().includes(term) ||
        propietario.cargoData.cargos.toLowerCase().includes(term) ||
        propietario.condicionLaboral.label.toLowerCase().includes(term) ||
        propietario.telfijo.toLowerCase().includes(term) ||
        propietario.telcel.toLowerCase().includes(term)
      );
    });
  }

  toggleDropdown(index: number) {
    this.dropdownStates = this.dropdownStates.map((state, i) => (i === index ? !state : false));
  }

 listarPropietarios(): void {
  this.isLoading = true;
  this.propietarioService.getPropietarios().subscribe({
    next: (data) => {
      setTimeout(() => { // Simula retraso de 1.5 segundos
        if (data?.propietarios) {
          this.propietarios = data.propietarios;
        }
        this.filteredTableItems = [...this.propietarios];
        this.isLoading = false;
      }, 1);
    },
    error: (err) => {
      this.isLoading = false;
      console.error('Error cargando propietarios', err);
    }
  });
}

  getPropietariobyId(IdPersona: string): void {
    this.propietarioService.getPropietariobyIdPersona(IdPersona).subscribe({
      next: (data) => {
       // console.log('Propietario recibido:', data);
        this.propietarios = data;
      },
      error: (error) => {
        console.error('Error al obtener el propietario:', error.message);
      }
    });
  }

  //recibe el id de la tabla vista, nombre con el que descargará el archivo, titulo del documento
  exportToPDF(tableId: string, nameFile: string, titleFile: string) {
    Utils.exportToPDF(tableId, nameFile, titleFile);
  }


  exportarExcel(tableId: string, nameFile: string) {
    Utils.exportVisibleTableToExcel(tableId, nameFile);
  }

  inactivarPersona(idPersona: string) {

    this.avisoInactivarPersona(idPersona);
  }

  avisoInactivarPersona(idPersona: string) {
    Swal.fire({
      title: "INACTIVAR",
      text: "¿Desea inactivar a la persona con NIP: " + idPersona + "?",
      icon: "question",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Aceptar",
      cancelButtonText: "Cancelar",
    }).then((result) => {
      if (result.isConfirmed) {
        //consume el metodo para actualiza el estado de la persona
        this.propietarioService.updatePropietariosEstado(idPersona, 0).subscribe({
          next: (response) => {

            Swal.fire({
              icon: 'success',
              title: '¡Éxito!',
              text: response.message,
              confirmButtonText: 'Aceptar'
            });

            // 🔹 Refrescar la lista de propietarios
            this.listarPropietarios();
          },
          error: (error) => console.error('Error:', error)
        });

      }
    });
  }


  editarPersona(idPersona: string) {
    console.log(idPersona);
    // this.router.navigate(['/persona/editar']);
    this.router.navigate(['/persona/editar', idPersona]);
  }

  cargarDocumentos(idPersona: string) {
    console.log(idPersona);
    this.router.navigate(['/digitales/digitales', idPersona]);
  }

  async getFotoPersona(idPersona: string): Promise<void> {
    const basePath = `${this.empresaId}/personas/${idPersona}/FT_${idPersona}`;
    const fallback = "../../../../../assets/images/hoja_vida/sinfoto.png";

    try {
      // Detectar extensión real (jpg, png, pdf, etc)
      const ext = await this.detectarExtensionSoporte(basePath);
      if (ext) {
        const path = `${basePath}.${ext}`;
        const signed = await this.gpcGoogle.getSignedUrl(path).toPromise();
        const url = signed?.url;
        if (url && (ext === 'jpg' || ext === 'jpeg' || ext === 'png')) {
          this.fotoBase64 = await this.gpcGoogle.getImageBase64(url);
        } else {
          // Si es PDF u otro formato no imagen, usar fallback
          this.fotoBase64 = await this.gpcGoogle.getImageBase64(fallback);
        }
      } else {
        this.fotoBase64 = await this.gpcGoogle.getImageBase64(fallback);
      }
    } catch (error) {
      console.warn('⚠️ Error al obtener la foto, usando fallback:', error);
      this.fotoBase64 = await this.gpcGoogle.getImageBase64(fallback);
    }
  }


  async ExportaHV(idPersona: string) {
    this.mostrandoToast = true;

    try {
      await this.getFotoPersona(idPersona);
      const data = await firstValueFrom(this.propietarioService.getPropietariobyIdPersona(idPersona));
      this.propietario = data;

      const doc = new jsPDF({
        orientation: "portrait", // Vertical
        unit: "mm",
        compress: true,
        format: "letter", // Tamaño carta (216 × 279 mm)
        putOnlyUsedFonts: true, // Carga solo las fuentes usadas (más rápido)
        floatPrecision: 2, // Reduce precisión para mejorar velocidad/renderizado
      });

      // Ruta de la imagen en assets
      const imgUrl = "../../../../../assets/images/hoja_vida/banner.jpg";

      // Convertir imagen en base64
      const imgData = await this.getBase64Image(imgUrl);
      doc.addImage(imgData, "JPG", 0, 0, 178, 270); // Agregar imagen al PDF

      if (this.fotoBase64?.trim()) {
        doc.addImage(this.fotoBase64, "JPG", 27, 20, 30, 40);
      }

      // ✍️ Agregar el nombre debajo de la foto
      doc.setFont("helvetica", "bold");
      doc.setFontSize(18);
      doc.setTextColor(0, 0, 0);
      const nombreCompleto = data.segundonombre
        ? `${data.primernombre.toUpperCase()} ${data.segundonombre.toUpperCase()}`
        : data.primernombre.toUpperCase();

      // Obtener los apellidos
      const apellidos = `${(data.papellidos || '').toUpperCase()} ${(data.seapellidos || '').toUpperCase()}`;
      doc.text(nombreCompleto, 40, 70, { align: "center" });
      doc.text(apellidos, 40, 78, { align: "center" });

      doc.setTextColor(0, 0, 0);
      doc.setFillColor(240, 240, 240);
      doc.roundedRect(2, 90, 75, 13, 1, 1, "F"); // Rectángulo redondeado
      doc.setFontSize(10);

      doc.setFontSize(12);

      // 📌 Centrar el texto en el rectángulo
      doc.setFont("helvetica", "bold");
      const text = data.cargoData?.cargos || "Sin cargo";
      const textWidth = doc.getTextWidth(text); // Obtener ancho del texto
      const centerX = 2 + (75 / 2) - (textWidth / 2); // Centrado en X
      const centerY = 88 + (13 / 2) + 3; // Centrado en Y (ajustado)
      doc.text(text, centerX, centerY);

      doc.setFontSize(10);
      doc.setTextColor(0, 0, 0);
      doc.setFont("helvetica", "bold");

      // 🔹 Validar tipo y cédula
      const tipoCedula = data.tipo && data.cedula ? `${data.tipo} ${data.cedula}` : "No disponible";
      doc.text(tipoCedula, 5, 110);

      // 🔹 Validar lugar de expedición
      const lugarExpedicion = data.LugarExpData?.MUNICIPIO ? `Expedida en: ${data.LugarExpData.MUNICIPIO}` : "Expedida en: No disponible";
      doc.text(lugarExpedicion, 5, 110 + 6);

      // 🔹 Validar fecha de nacimiento
      const fechaNacimiento = data.fechanace ? `Fecha Nacimiento: ${data.fechanace}` : "Fecha Nacimiento: No disponible";
      doc.text(fechaNacimiento, 5, 110 + 12);

      // 🔹 Validar lugar de nacimiento
      const lugarNacimiento = data.LugarNacimientoData?.MUNICIPIO ? `Lugar de Nacimiento: ${data.LugarNacimientoData.MUNICIPIO}` : "Lugar de Nacimiento: No disponible";
      doc.text(lugarNacimiento, 5, 110 + 18);

      // 🔹 Validar estado civil
      const estadoCivil = data.estadoCivil?.descripcion ? `Estado Civil: ${data.estadoCivil.descripcion}` : "Estado Civil: No disponible";
      doc.text(estadoCivil, 5, 110 + 24);

      doc.setTextColor(0, 0, 0);
      doc.setFillColor(240, 240, 240);
      doc.roundedRect(2, 140, 75, 13, 1, 1, "F"); // Rectángulo redondeado

      // ✍️ Texto dentro del rectángulo
      doc.setFontSize(12);

      const text2 = "CONTACTO";
      doc.setTextColor(0, 0, 0);
      doc.setFillColor(240, 240, 240);
      const textWidth2 = doc.getTextWidth(text2);
      const centerX2 = 2 + (75 / 2) - (textWidth2 / 2);
      const centerY2 = 139 + (13 / 2) + 3;
      doc.text(text2, centerX2, centerY2);

      // Configuración de datos de contacto
      doc.setFontSize(10);
      doc.setTextColor(0, 0, 0);
      doc.text(data.direccion || "Sin dirección registrada", 5, 160);

      // 🔍 Validación del municipio
      const municipio = data.MunicipioData?.MUNICIPIO ? data.MunicipioData.MUNICIPIO : " - ";
      const barrio = data.barrio || " - ";

      doc.text(`${municipio} - ${barrio}`, 5, 166);
      doc.text(data.telcel || " - ", 5, 172);
      doc.text(data.mail || " - ", 5, 178);

      doc.setTextColor(0, 0, 0);
      doc.setFillColor(240, 240, 240);
      doc.roundedRect(2, 190, 75, 13, 1, 1, "F");

      // ✍️ Encabezado "LICENCIA DE CONDUCCIÓN"
      doc.setFontSize(12);
      const text3 = "LICENCIA DE CONDUCCIÓN";
      const textWidth3 = doc.getTextWidth(text3);
      const centerX3 = 2 + (75 / 2) - (textWidth3 / 2);
      const centerY3 = 188 + (13 / 2) + 3;
      doc.text(text3, centerX3, centerY3);

      doc.setFontSize(10);
      doc.setTextColor(0, 0, 0);

      // ✅ Validación de licencia y categoría
      const numeroLic = data.numerolic ? data.numerolic.trim() : "-";
      const categoria = data.categoria && data.categoria.trim() !== "" ? ` - ${data.categoria}` : "";
      doc.text(numeroLic + categoria, 5, 210);

      // ✅ Validación de fecha de vencimiento
      if (data.vencelic) {
        const fecha = new Date(data.vencelic);
        if (!isNaN(fecha.getTime())) {
          const fechaFormateada = fecha.toLocaleDateString("es-ES", { day: "2-digit", month: "2-digit", year: "numeric" });
          doc.text("Vencimiento: " + fechaFormateada, 5, 216);
        } else {
          doc.text("Vencimiento: Fecha no válida", 5, 216);
        }
      }

      // ✅ Validación de tipo de sangre
      const tipoSangre = data.sangre ? data.sangre.trim() : "No especificado";
      doc.text("RH: " + tipoSangre, 5, 222);

      // 🔹 Encabezado "Experiencia Laboral"
      doc.setFillColor(240, 240, 240);
      doc.roundedRect(85, 15, 115, 15, 3, 3, "F");
      doc.setFont("helvetica", "bold");
      doc.setTextColor(0, 0, 0);
      doc.setFontSize(16);
      doc.text("EXPERIENCIA LABORAL", 140, 25, { align: "center" });

      let yx = 37;
      if (data.LaboralData && Array.isArray(data.LaboralData) && data.LaboralData.length > 0) {
        data.LaboralData.forEach((exp: any) => {
          this.addExperience(
            doc,
            exp.empresa || "Desconocido",
            exp.cargo || "N/A",
            exp.tiempo ? exp.tiempo.toString() : "N/A",
            exp.telefono || "N/A",
            yx
          );
          yx += 30; // Espaciado entre registros laborales
        });
      } else {
        // ✅ Mensaje cuando no tiene experiencia laboral
        doc.setFontSize(12);
        doc.setTextColor(255, 0, 0); // Rojo para resaltar el mensaje
        doc.text("Sin experiencia laboral registrada", 95, yx);
        doc.setTextColor(0, 0, 0); // Restaurar el color del texto a negro
      }

      // 🔹 Encabezado "Formación Académica"
      doc.setFillColor(240, 240, 240);
      doc.roundedRect(85, 92, 115, 15, 3, 3, "F");
      doc.setFontSize(16);
      doc.setTextColor(0, 0, 0);
      doc.setFont("helvetica", "bold");
      doc.text("FORMACIÓN ACADEMICA", 142, 101, { align: "center" });

      let y = 115; // Posición inicial en el PDF

      // Verificar si hay datos académicos
      if (data.AcademicoData && data.AcademicoData.length > 0) {
        data.AcademicoData.forEach((edu: any) => {
          this.addEducation(
            doc,
            (edu.entidad || "Desconocido").trim(),  // 🔹 Elimina `\r\n` si lo hay
            edu.nivel.nombre || "N/A",
            edu.titulo || "Desconocido",
            edu.terminacion || "N/A",
            edu.tiempo || 0,
            y
          );
          y += 30; // Espaciado entre registros académicos
        });
      } else {
        doc.setFontSize(12);
        doc.setTextColor(255, 0, 0); // 🔴 Color rojo para destacar
        doc.text("No hay formación académica registrada", 85, y);
      }

      doc.setFillColor(240, 240, 240); // Color de fondo gris claro
      doc.roundedRect(85, 175, 115, 15, 3, 3, "F"); // Rectángulo redondeado
      doc.setFont("helvetica", "bold");
      doc.setTextColor(0, 0, 0);
      doc.setFontSize(16);
      doc.text("CURSOS", 140, 185, { align: "center" });

      let yy = 200;
      if (data.CursoData && data.CursoData.length > 0) {
        data.CursoData.forEach((edu: any) => {
          this.addCursos(
            doc,
            (edu.entidad || "Desconocido").trim(),
            String(edu.tipoestudio) || "N/A", // 🔹 Convertir a string
            edu.titulo || "Desconocido",
            edu.terminacion || "N/A",
            String(edu.tiempo) || "0", // 🔹 Convertir a string
            yy
          );
          yy += 30;
        });
      } else {
        doc.setFontSize(12);
        doc.setTextColor(255, 0, 0); // 🔴 Texto en rojo para destacar
        doc.text("No hay cursos registrados", 85, yy);
      }

      // 🔥 Footer
      this.addFooter(doc);

      // 📄 Generar el PDF y abrir en nueva pestaña
      const pdfBlob = doc.output("blob");
      const pdfUrl = URL.createObjectURL(pdfBlob);
      window.open(pdfUrl, "_blank");
    } catch (error: any) {
      console.error('Error al generar hoja de vida:', error);
      this.toastrService.error('Error al generar la hoja de vida', 'Error');
    } finally {
      this.mostrandoToast = false;
    }
  }

  // Función para agregar un header con solo contorno
    addHeader(doc: jsPDF,title:string) {
      const pageWidth = 216;       // Ancho total en mm (Letter)
      const marginLeft = 1;       // Margen izquierdo deseado
      const marginRight = 1;      // Margen derecho igual para simetría
      const rectY = 1;            // Distancia desde la parte superior
      const headerHeight = 22    // Altura del encabezado
      const rectWidth = pageWidth - marginLeft - marginRight;
  
      // Dibujar el rectángulo del encabezado
      doc.setDrawColor(0, 0, 0);   // Borde negro
      doc.setLineWidth(0.5);       // Grosor del borde
      doc.rect(marginLeft, rectY, rectWidth, headerHeight);
  
      // Título centrado dentro del rectángulo
      doc.setFontSize(14);
      doc.setTextColor(0, 0, 0);
  
      const text = title;
      const centerX = marginLeft + rectWidth / 2;
      const textY = rectY + 12; // Ajuste vertical para ubicar el texto dentro del rectángulo
  
      doc.text(text, centerX, textY, { align: "center" });
    }

  // Llamar la función en la generación del PDF



  async ExportaFichaTecnica(idPersona: string) {
    this.mostrandoToast = true;

    try {
      const docsConfig = await firstValueFrom(this.documentosService.getDocumentosByTipoEntidad(1));
      this.archivos = docsConfig.map(doc => ({
        ...doc,
        acceptedFormats: doc.formatos.split(","),
        prefijo: doc.sigla
      }));

      const data = await firstValueFrom(this.propietarioService.getPropietariobyIdPersona(idPersona));
      this.propietario = data;

      const doc = new jsPDF({
        orientation: "portrait",
        unit: "mm",
        compress: false,
        format: "letter",
      });

      this.addHeader(doc, "FICHA TÉCNICA DE PERSONAS");

      const getSignedUrlSafe = async (path: string) => {
        try {
          const res = await firstValueFrom(this.gpcGoogle.getSignedUrl(path));
          return res?.url || null;
        } catch {
          return null;
        }
      };

      const getBase64FromBasePath = async (basePath: string, fallbackPath: string) => {
        const ext = await this.detectarExtensionSoporte(basePath);
        if (!ext || !['jpg', 'jpeg', 'png'].includes(ext.toLowerCase())) {
          return this.gpcGoogle.getImageBase64(fallbackPath);
        }

        const signedUrl = await getSignedUrlSafe(`${basePath}.${ext}`);
        if (!signedUrl) {
          return this.gpcGoogle.getImageBase64(fallbackPath);
        }

        try {
          return await this.gpcGoogle.getImageBase64(signedUrl);
        } catch {
          return this.gpcGoogle.getImageBase64(fallbackPath);
        }
      };

      const fallback = "../../../../../assets/images/hoja_vida/sinfoto.png";
      const imageBasePaths = {
        supertransporte: 'ministerio/supertransporte',
        logo: `${this.empresaId}/logos/logo`,
        foto: `${this.empresaId}/personas/${idPersona}/FT_${idPersona}`,
        cc1: `${this.empresaId}/personas/${idPersona}/CC1_${idPersona}`,
        cc2: `${this.empresaId}/personas/${idPersona}/CC2_${idPersona}`,
        lpf: `${this.empresaId}/personas/${idPersona}/LPF_${idPersona}`,
        lpp: `${this.empresaId}/personas/${idPersona}/LPP_${idPersona}`
      };

      const [
        base64Image,
        base64Logo,
        fotoBase64,
        base64CC1,
        base64CC2,
        base64LPF,
        base64LPP
      ] = await Promise.all([
        getBase64FromBasePath(imageBasePaths.supertransporte, fallback),
        getBase64FromBasePath(imageBasePaths.logo, fallback),
        getBase64FromBasePath(imageBasePaths.foto, fallback),
        getBase64FromBasePath(imageBasePaths.cc1, fallback),
        getBase64FromBasePath(imageBasePaths.cc2, fallback),
        getBase64FromBasePath(imageBasePaths.lpf, fallback),
        getBase64FromBasePath(imageBasePaths.lpp, fallback)
      ]);

      this.fotoBase64 = fotoBase64;
      this.base64CC1 = base64CC1;
      this.base64CC2 = base64CC2;
      this.base64LPF = base64LPF;
      this.base64LPP = base64LPP;

      const imgUrl = "../../../../../assets/images/hoja_vida/banner.jpg";
      const imgData = await this.getBase64Image(imgUrl);

      if (base64Logo) doc.addImage(base64Logo, "JPG", this.posicionX, this.posicionY, this.ancho, this.altura, undefined, 'FAST');
      if (base64Image) doc.addImage(base64Image, "JPG", 170, 5, 35, 12, undefined, 'FAST');
      if (imgData) doc.addImage(imgData, "JPG", 0, 24, 184, 250, undefined, 'FAST');
      if (this.fotoBase64?.trim()) doc.addImage(this.fotoBase64, "JPG", 30, 40, 20, 25, undefined, 'FAST');
      if (this.base64CC1?.trim()) doc.addImage(this.base64CC1, "JPG", 95, 30, 80, 50, undefined, 'FAST');
      if (this.base64CC2?.trim()) doc.addImage(this.base64CC2, "JPG", 95, 85, 80, 50, undefined, 'FAST');
      if (this.base64LPF?.trim()) doc.addImage(this.base64LPF, "JPG", 95, 153, 80, 50, undefined, 'FAST');
      if (this.base64LPP?.trim()) doc.addImage(this.base64LPP, "JPG", 95, 206, 80, 50, undefined, 'FAST');

      doc.setDrawColor(0, 0, 0);
      doc.setLineWidth(0.5);
      doc.roundedRect(93, 30, 84, 105, 4, 4);
      doc.roundedRect(93, 153, 84, 105, 4, 4);

      doc.setFont("helvetica", "bold");
      doc.setFontSize(18);
      doc.setTextColor(0, 0, 0);
      const nombreCompleto = data.segundonombre
        ? `${data.primernombre.toUpperCase()} ${data.segundonombre!.toUpperCase()}`
        : data.primernombre.toUpperCase();
      const apellidos = `${(data.papellidos || '').toUpperCase()} ${(data.seapellidos || '').toUpperCase()}`;
      doc.text(nombreCompleto, 40, 72, { align: "center" });
      doc.text(apellidos, 40, 80, { align: "center" });

      doc.setTextColor(0, 0, 0);
      doc.setFillColor(240, 240, 240);
      doc.roundedRect(2, 90, 75, 13, 1, 1, "F");
      doc.setFontSize(12);

      doc.setFont("helvetica", "bold");
      const text = data.cargoData?.cargos || "Sin cargo";
      const textWidth = doc.getTextWidth(text);
      const centerX = 2 + (75 / 2) - (textWidth / 2);
      const centerY = 88 + (13 / 2) + 3;
      doc.text(text, centerX, centerY);

      doc.setFontSize(10);
      doc.setTextColor(0, 0, 0);
      doc.setFont("helvetica", "bold");

      const tipoCedula = data.tipo && data.cedula ? `${data.tipo} ${data.cedula}` : "No disponible";
      doc.text(tipoCedula, 5, 110);

      const lugarExpedicion = data.LugarExpData?.MUNICIPIO ? `Expedida en: ${data.LugarExpData.MUNICIPIO}` : "Expedida en: No disponible";
      doc.text(lugarExpedicion, 5, 116);

      const fechaNacimiento = data.fechanace ? `Fecha Nacimiento: ${data.fechanace}` : "Fecha Nacimiento: No disponible";
      doc.text(fechaNacimiento, 5, 122);

      const lugarNacimiento = data.LugarNacimientoData?.MUNICIPIO ? `Lugar de Nacimiento: ${data.LugarNacimientoData.MUNICIPIO}` : "Lugar de Nacimiento: No disponible";
      doc.text(lugarNacimiento, 5, 128);

      const estadoCivil = data.estadoCivil?.descripcion ? `Estado Civil: ${data.estadoCivil.descripcion}` : "Estado Civil: No disponible";
      doc.text(estadoCivil, 5, 134);

      doc.setTextColor(0, 0, 0);
      doc.setFillColor(240, 240, 240);
      doc.roundedRect(2, 140, 75, 13, 1, 1, "F");

      doc.setFontSize(12);
      const text2 = "CONTACTO";
      const textWidth2 = doc.getTextWidth(text2);
      const centerX2 = 2 + (75 / 2) - (textWidth2 / 2);
      const centerY2 = 139 + (13 / 2) + 3;
      doc.text(text2, centerX2, centerY2);

      doc.setFontSize(10);
      doc.setTextColor(0, 0, 0);
      doc.text(data.direccion || "Sin dirección registrada", 5, 160);

      const municipio = data.MunicipioData?.MUNICIPIO ? data.MunicipioData.MUNICIPIO : " - ";
      const barrio = data.barrio || " - ";
      doc.text(`${municipio} - ${barrio}`, 5, 166);
      doc.text(data.telcel || " - ", 5, 172);
      doc.text(data.mail || " - ", 5, 178);

      doc.setTextColor(0, 0, 0);
      doc.setFillColor(240, 240, 240);
      doc.roundedRect(2, 190, 75, 13, 1, 1, "F");

      doc.setFontSize(12);
      const text3 = "LICENCIA DE CONDUCCIÓN";
      const textWidth3 = doc.getTextWidth(text3);
      const centerX3 = 2 + (75 / 2) - (textWidth3 / 2);
      const centerY3 = 188 + (13 / 2) + 3;
      doc.text(text3, centerX3, centerY3);

      doc.setFontSize(10);
      doc.setTextColor(0, 0, 0);

      const numeroLic = data.numerolic ? data.numerolic.trim() : "-";
      const categoria = data.categoria && data.categoria.trim() !== "" ? ` - ${data.categoria}` : "";
      doc.text(numeroLic + categoria, 5, 210);

      if (data.vencelic) {
        const fecha = new Date(data.vencelic);
        if (!isNaN(fecha.getTime())) {
          const fechaFormateada = fecha.toLocaleDateString("es-ES", { day: "2-digit", month: "2-digit", year: "numeric" });
          doc.text("Vencimiento: " + fechaFormateada, 5, 216);
        } else {
          doc.text("Vencimiento: Fecha no válida", 5, 216);
        }
      }

      const tipoSangre = data.sangre ? data.sangre.trim() : "No especificado";
      doc.text("RH: " + tipoSangre, 5, 222);

      this.addFooter(doc);
      const pdfBytes = doc.output("arraybuffer");

      const signedPdfUrls: Record<string, string | null> = {
        RUT: null,
        CTP: null,
        EXM: null,
        CMD: null,
        SSS: null,
      };

      for (const archivo of this.archivos) {
        if (archivo.cargarDigital === 1 && signedPdfUrls.hasOwnProperty(archivo.sigla)) {
          signedPdfUrls[archivo.sigla] = await getSignedUrlSafe(`${this.empresaId}/personas/${idPersona}/${archivo.sigla}_${idPersona}.pdf`);
        }
      }

      const fetchPdf = async (url: string): Promise<Uint8Array> => {
        const response = await fetch(url);
        if (!response.ok) throw new Error("No se pudo descargar el PDF");
        return new Uint8Array(await response.arrayBuffer());
      };

      const optionalPdfs: Array<Uint8Array> = [];
      for (const sigla of Object.keys(signedPdfUrls)) {
        const url = signedPdfUrls[sigla];
        if (!url) continue;
        try {
          const bytes = await fetchPdf(url);
          optionalPdfs.push(bytes);
        } catch (e) {
          console.warn(`No se pudo obtener el PDF ${sigla}:`, e);
        }
      }

      const mergedPdf = await PDFDocument.create();

      const jsPdfDoc = await PDFDocument.load(pdfBytes);
      const jsPdfPages = await mergedPdf.copyPages(jsPdfDoc, jsPdfDoc.getPageIndices());
      jsPdfPages.forEach((page) => mergedPdf.addPage(page));

      for (const pdfBytesExtra of optionalPdfs) {
        try {
          const extraDoc = await PDFDocument.load(pdfBytesExtra);
          const extraPages = await mergedPdf.copyPages(extraDoc, extraDoc.getPageIndices());
          extraPages.forEach((page) => mergedPdf.addPage(page));
        } catch (e) {
          console.warn("No se pudo fusionar un PDF adicional:", e);
        }
      }

      mergedPdf.setTitle('');
      mergedPdf.setAuthor('');
      mergedPdf.setProducer('');
      mergedPdf.setCreator('');
      mergedPdf.setSubject('');

      const finalPdfBytes = await mergedPdf.save({
        useObjectStreams: true,
        addDefaultPage: false,
      });

      const pdfArrayBuffer = finalPdfBytes.buffer.slice(
        finalPdfBytes.byteOffset,
        finalPdfBytes.byteOffset + finalPdfBytes.byteLength,
      ) as ArrayBuffer;

      const blob = new Blob([pdfArrayBuffer], { type: "application/pdf" });
      const url = URL.createObjectURL(blob);
      window.open(url, "_blank");
    } catch (error: any) {
      console.error('Error al generar el documento:', error);
      this.toastrService.error('Error al generar el documento', 'Error');
    } finally {
      this.mostrandoToast = false;
    }
  }

  addExperience(doc: jsPDF, empresa: string, cargo: string, tiempo: number | string, telefono: string, y: number) {
    doc.setTextColor(0, 0, 0);
    doc.setFontSize(10);
    doc.setFont("helvetica", "bold");
    doc.text(`EMPRESA: ${empresa}`, 90, y);
    doc.setFont("helvetica", "normal");
    doc.text(`CARGO: ${cargo}`, 90, y + 6);
    doc.text(`TIEMPO: ${tiempo.toString()} meses`, 90, y + 12); // Convierte el tiempo a string si es necesario
    doc.text(`TELÉFONO: ${telefono}`, 90, y + 18);
  }

  // 🔹 Función para agregar educación
  // 🔹 Función mejorada para agregar educación al PDF
  addEducation(
    doc: jsPDF,
    institucion: string,
    nivel: string,
    carrera: string,
    terminacion: string,
    tiempo: number,
    y: number
  ) {
    doc.setTextColor(0, 0, 0);
    doc.setFontSize(10);
    doc.setFont("helvetica", "bold");
    doc.text(institucion.trim(), 90, y); // 🔹 Eliminamos caracteres no deseados
    doc.setFont("helvetica", "normal");
    doc.text(`Nivel: ${nivel}`, 90, y + 6);
    doc.text(`Carrera: ${carrera}`, 90, y + 12);
    doc.text(`Finalización: ${terminacion} (${tiempo} años)`, 90, y + 18);
  }


  // 🔹 Función para agregar addCursos
  addCursos(doc: jsPDF, institucion: string, nivel: string, carrera: string, año: string, tiempo: string, y: number) {
    doc.setTextColor(0, 0, 0);
    doc.setFontSize(10);
    doc.setFont("helvetica", "bold");
    doc.text(institucion, 90, y);
    doc.setFont("helvetica", "normal");
    doc.text(nivel, 90, y + 6);
    doc.text(carrera, 90, y + 12);
    doc.text(`Finalización: ${año} (${tiempo} horas)`, 90, y + 18);
  }



  // 🔹 Función para agregar footer correctamente
  addFooter(doc: jsPDF) {
    const pageHeight = doc.internal.pageSize.height; // ✅ Obtener altura de la página correctamente
    doc.setFont("helvetica", "italic");
    doc.setFontSize(8);
    doc.setTextColor(100, 100, 100);
    doc.text("Hoja de Vida Generada by Admin SEAF - www.indesoftsas.com", 105, pageHeight - 8, { align: "center" });
  }


  // Convertir imagen a Base64
  getBase64Image(imgUrl: string): Promise<string> {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.src = imgUrl;
      img.crossOrigin = "Anonymous"; // Evita problemas de CORS

      img.onload = () => {
        const canvas = document.createElement("canvas");
        canvas.width = img.width;
        canvas.height = img.height;
        const ctx = canvas.getContext("2d");
        ctx?.drawImage(img, 0, 0);
        resolve(canvas.toDataURL("image/png")); // Convertir a Base64
      };

      img.onerror = (error) => reject(error);
    });
  }
  async addFooterToPdf(pdfBytes: Uint8Array | ArrayBuffer) {
    const pdfDoc = await PDFDocument.load(pdfBytes);
    const pages = pdfDoc.getPages();
    const font = await pdfDoc.embedFont(StandardFonts.HelveticaOblique);

    pages.forEach(page => {
      const { width, height } = page.getSize();
      const footerText = "Ficha Técnica de Personas - Generada by Admin SEAF - www.indesoftsas.com";
      const fontSize = 8;

      // Medir ancho del texto para centrar
      const textWidth = font.widthOfTextAtSize(footerText, fontSize);
      const x = (width - textWidth) / 2;
      const y = 15; // Altura desde abajo, ajusta si quieres más arriba o abajo

      page.drawText(footerText, {
        x,
        y,
        size: fontSize,
        font,
        color: rgb(0.39, 0.39, 0.39), // gris similar a (100,100,100) en 0-1 escala
      });
    });

    return await pdfDoc.save();
  }


  filterData() {
    const search = this.searchText.trim().toLowerCase();
    if (!search) {
      this.filteredTableItems = [...this.propietarios];
    } else {
      this.filteredTableItems = this.propietarios.filter((item) =>
        (
          (item.primernombre || ' ') +
          (item.segundonombre || ' ') +
          (item.papellidos || ' ') +
          (item.seapellidos || ' ') +
          (item.cedula || ' ') +
          (item.cargoData.cargos || ' ') +
          (item.mail || ' ') +
          (item.telcel || ' ')
        )
          .toLowerCase()
          .includes(search)
      );
    }
    this.page = 1; // Reiniciar a la primera página
  }

  sortData(column: string) {
    if (this.sortColumn === column) {
      this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
    } else {
      this.sortColumn = column;
      this.sortDirection = 'asc';
    }

    const listToSort = this.filteredTableItems.length ? this.filteredTableItems : this.propietarios;

    listToSort.sort((a, b) => {
      let aVal = this.getNestedValue(a, column);
      let bVal = this.getNestedValue(b, column);

      if (typeof aVal === 'string') aVal = aVal.toLowerCase();
      if (typeof bVal === 'string') bVal = bVal.toLowerCase();

      if (aVal < bVal) return this.sortDirection === 'asc' ? -1 : 1;
      if (aVal > bVal) return this.sortDirection === 'asc' ? 1 : -1;
      return 0;
    });

    this.page = 1; // Reiniciar paginación
  }

  getNestedValue(obj: any, path: string): any {
    return path.split('.').reduce((acc, part) => acc && acc[part], obj) ?? '';
  }
  private cargarDataAdmin(): void {
    this.administracionesServices.obtenerTodas().subscribe({
      next: (data) => {

        this.administraciones = data;
        this.empresaId = this.administraciones[0].nit;
        this.altura = data[0].dimensionLogo.h;      // "8"
        this.ancho = data[0].dimensionLogo.w;       // "40"
        this.posicionX = data[0].dimensionLogo.x;   // 10
        this.posicionY = data[0].dimensionLogo.y;  
        // console.log(this.empresaId);
      },
      error: (err) => {
        console.error("Error al cargar los conductores:", err);
      },
    });
  }



}




